import React from 'react';
import './CSS/Enterprise.css';

import { PiChartLineUp } from "react-icons/pi";
import { GiPuzzle } from "react-icons/gi";
import { MdOutlineSentimentSatisfiedAlt } from "react-icons/md";
import { FaHandshake } from "react-icons/fa";
import { BsSignStopFill } from "react-icons/bs";
import { FaPeopleGroup } from "react-icons/fa6";
import analyticsImage from "../../Assets/Images/analytics.png";
import {Link} from "react-router-dom";



const Enterprise: React.FC = () => {
    return (
        <div>
            <section className="enterprise-header">
                <div className="enterprise-header-text">
                    <h2>VIZEdi for Enterprise: Deeper Insights for Building Lasting Belonging in the Workplace</h2>
                    <p>
                        Empower your team to learn about their communication habits with advanced insights and build
                        belonging.
                    </p>
                </div>
                <div className="enterprise-header-image">
                    <img src={analyticsImage} alt="VIZEdi™ App on Laptop"/>
                </div>
            </section>

            <section className="enterprise-section">
                <h2>What Is VIZEdi for Enterprise?</h2>
                <p className="what-is-desc">
                    VIZEdi for enterprise integrates with Microsoft Teams to go beyond real-time term checking by
                    offering a
                    Personal Dashboard—a deep dive into how you collaborate with your team, helping you enhance your
                    communication skills to strengthen the sense of belonging in your workplace.
                </p>
            </section>

            <section className="enterprise-section">
                <h2>Dashboard Features that Build Belonging</h2>
                <h3>You’ll get insights into how your communication style varies across different groups, whether by
                    demographic diversity or team roles.</h3>
                <div className="enterprise-grid">
                    <div className="enterprise-grid-item">
                        <PiChartLineUp className="icon"/>
                        <h3>Term Improvements</h3>
                        <p>Track your improvements in choosing terms that build
                            belonging.</p>
                    </div>
                    <div className="enterprise-grid-item">
                        <GiPuzzle className="icon"/>
                        <h3>Contribution</h3>
                        <p>Measure how much you contribute to conversations to make sure
                            you're engaging your entire team fairly.</p>
                    </div>
                    <div className="enterprise-grid-item">
                        <MdOutlineSentimentSatisfiedAlt className="icon"/>
                        <h3>Tone</h3>
                        <p>Find out if the tone of your messages changes when communicating with
                            people of different roles or backgrounds.</p>
                    </div>
                </div>
            </section>

            <section className="enterprise-section">
                <h2>Benefits</h2>
                <div className="enterprise-grid">
                    <div className="enterprise-grid-item">
                        <FaPeopleGroup className="icon"/>
                        <h3>Foster Belonging</h3>
                        <p>Ensure all team members are included and valued in the
                            conversations.</p>
                    </div>
                    <div className="enterprise-grid-item">
                        <BsSignStopFill className="icon"/>
                        <h3>Prevent Unconscious Bias</h3>
                        <p>Gain visibility into any biases in your communication
                            patterns and adjust accordingly.</p>
                    </div>
                    <div className="enterprise-grid-item">
                        <FaHandshake className="icon"/>
                        <h3>Promote Collaboration</h3>
                        <p>Ensure you’re giving equal space to voices across your
                            team, improving collaboration and teamwork.</p>
                    </div>
                </div>
            </section>

            <section className="enterprise-section">
                <h2>Company Reports</h2>
                <p>Gain actionable insights at the company level to foster inclusivity and team collaboration.</p>
            </section>

            <div className="cta-section">
                <h2 className="cta-title">Unlock Your Personal Dashboard with VIZEdi for Enterprise</h2>
                <p className="cta-description">
                    Deeper Insights for building lasting belonging in the workplace
                </p>
                <Link to="/login">
                    <button className="cta-button">Start Now</button>
                </Link>
            </div>
        </div>
    );
};

export default Enterprise;
